<template>
  <div id="sweetCalendar">
    <div class="container calendar">
      <div class="header">
        <div class="left-arrow">
          <span
            @click="prevMonth"
            v-show="isLeftArrowEnabled"
          >&lt;</span>
        </div>
        <div class="month">{{ selectedMonthName }} {{ selectedYear }}</div>
        <div class="right-arrow">
          <span
            @click="nextMonth"
            v-show="isRightArrowEnabled"
          >&gt;</span>
        </div>
      </div>
      <div class="body" :class="highlightSelectDate ? 'highlight-date' : ''">
        <div
          v-for="(day, index) in weekdays"
          :key="`day-name-${index + 1}`"
          class="day-name"
          :title="day"
        >
          {{ day[0] }}
        </div>
        <div
          v-for="(day,index) in days"
          :key="index"
          class="day-container"
          @click="clickedDay(day)"
          :class="[
            isWeekHighlight(day, index),
            (day && day.getMonth() && day.getMonth() !== selectedMonth ? 'disabled' : '')
          ]"
        >
          <div
            class="before"
            v-if="day && day.getMonth() && day.getMonth() === selectedMonth"
            :style="generateBeforeStyle(day)"
          >&nbsp;</div>
          <div
            v-if="day"
            :class="[
            'day',
            `day-${day.getDate()},
            weekday-${day.getDay()}`,
            offDays.includes(day.getDay()) ? 'off-day' : null,
            day.toDateString() === today.toDateString() ? 'today' : null,
            isSelected(day) ? 'selected' : null,

            ]"
            :style="generateDayStyle(day)"
          >
            <span>{{ day.getDate() }}</span>
          </div>
          <div
            class="after"
            v-if="day && day.getMonth() && day.getMonth() === selectedMonth"
            :style="generateAfterStyle(day)"
          >&nbsp;</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import DateTime from '../DateTime.js'

export default {
  name: 'Calendar',
  data () {
    return {
      today: new DateTime(),
      selectedCalendarDate: new DateTime(),
      date: null,
      weekdays: null,
      isLeftArrowEnabled: true,
      isRightArrowEnabled: true,
      selectedDateFirstDayOfWeek: null
    }
  },
  computed: {
    days () {
      let emptyDays = Array(((this.startWeekDayOfMonth - this.firstDayOfWeek) + 7) % 7).fill(null)
      let days = Array(this.numberOfDays).fill().map((item, index) => new DateTime(this.selectedYear, this.selectedMonth, index + 1))
      if(this.showNextPrevMonthDays) {
        let previousMonthDays = []
        let nextMonthDays = []
        emptyDays.map((val, index) => {
          previousMonthDays.push( new DateTime( (((this.selectedMonth - 1) === 12) ? (this.selectedYear - 1) : this.selectedYear), (this.selectedMonth - 1), (this.numberOfDaysInLastMonth - index)))
        })
        previousMonthDays.reverse();
        let totalDays = previousMonthDays.concat(days)
        let minDays = 35
        let maxDays = 42 //only for when 6 rows 
        if(totalDays.length < minDays) {
          for(let i=1; i <= (minDays - totalDays.length); i++) {
            nextMonthDays.push( new DateTime( (((this.selectedMonth + 1) === 1) ? (this.selectedYear + 1) : this.selectedYear), (this.selectedMonth + 1), i))
          }
        } else if(totalDays.length > minDays && totalDays.length < maxDays) {
          for(let i=1; i <= (maxDays - totalDays.length); i++) {
            nextMonthDays.push( new DateTime( (((this.selectedMonth + 1) === 1) ? (this.selectedYear + 1) : this.selectedYear), (this.selectedMonth + 1), i))
          }
        }
        return totalDays.concat(nextMonthDays)
      } else {
        return emptyDays.concat(days)
      }
    },
    startWeekDayOfMonth () {
      return this.date.getFirstWeekdayOfMonth()
    },
    numberOfDays () {
      return this.date.getNumberOfDaysInMonth()
    },
    numberOfDaysInLastMonth () {
      return  this.date.getNumberOfDaysInLastMonth()
    },
    numberOfDaysInNextMonth () {
      return  this.date.getNumberOfDaysInNextMonth()
    },
    selectedMonth () {
      return this.date.getMonth()
    },
    selectedLastMonth () {
      return this.date.getLastMonth()
    },
    selectedMonthName () {
      return this.date.getMonthName()
    },
    selectedYear () {
      return this.date.getFullYear()
    }
  },
  watch: { },
  methods: {
    isWeekHighlight (day, index) {
      if(day && this.highlightWeek) {
        if(day.getMonth() === this.selectedMonth && this.selectedDateFirstDayOfWeek !== null ) {
          if(this.selectedDateFirstDayOfWeek <= (day.getDate())) {
            if((this.selectedDateFirstDayOfWeek+7) > (day.getDate()))
              return 'highlight-week'
          }
        }
        if(this.showNextPrevMonthDays) {
          if(day.getMonth() !== this.selectedMonth) {
            if(this.selectedDateFirstDayOfWeek < 0 && day.getDate() > 24 || this.selectedDateFirstDayOfWeek > 22 && day.getDate() < 7) {
              return 'highlight-week'
            }
          }
        }
      }
      return ''
    },
    clickedDay (day) {
      if (day !== null) {
        if(day.getMonth() !== this.selectedMonth && this.showNextPrevMonthDays) { //only if prev/next month days are enabled
          return
        }
        if( this.allowOffDaySelect ) { // allow off days to fire events
          if(this.highlightSelectDate || this.highlightWeek) {
            this.selectedCalendarDate = day._date
            this.getWeekDaysOfSelectedDsate(day)
          }
          this.$emit('click', day._date)
        } else {
          if(! this.offDays.includes(day.getDay())) { // off days do not fire events
            if(this.highlightSelectDate || this.highlightWeek) {
              this.selectedCalendarDate = day._date
              this.getWeekDaysOfSelectedDsate(day)
            }
            this.$emit('click', day._date)
          }
        }

      }
    },
    prevMonth () {
      this.selectedDateFirstDayOfWeek = null
      this.date = new DateTime(this.selectedYear, this.selectedMonth - 1, 1)
      // todo: block < if before beginDate
    },
    nextMonth () {
      this.selectedDateFirstDayOfWeek = null
      this.date = new DateTime(this.selectedYear, this.selectedMonth + 1, 1)
      // todo: block > if past endDate
    },
    generateWeekdayNames (firstDayOfWeek = 1) {
      let weekdays = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ]
      for (let i = 2; i <= firstDayOfWeek; i++) {
        let first = weekdays.shift()
        weekdays.push(first)
      }
      return weekdays
    },
    generateDayStyle (date) {
      if(date.getMonth() !== this.selectedMonth) {
        return
      }
      let style = { cursor: this.cursor }
      /*console.log( "generateDayStyle() date,type" ,date , typeof date )*/
      if (this.beginDate) {
        if (!date.isInRange(this.beginDate, this.endDate)) {
          return { cursor: 'not-allowed', color: '#999', background: '#555' } 
        }
      }
      for (let event of this.events) {
        if (date.isInRange(event.start, event.end, event.repeat)) {
          let category = this.eventCategories.find(item => item.id === event.categoryId) || {}
          Object.assign(style, {
            color: category.id ? category.textColor : null,
            backgroundColor: category.id ? category.backgroundColor : null,
            fontWeight: category.id ? 'bold' : 'normal',
            cursor: this.eventCursor
          })
        }
      }
      return style
    },
    generateBeforeStyle (date) {
      let style = {}
      for (let event of this.events) {
        if (date.isInRange(event.start, event.end, event.repeat) && date.getPrevDay().isInRange(event.start, event.end, event.repeat)) {
          let category = this.eventCategories.find(item => item.id === event.categoryId) || {}
          Object.assign(style, {
            backgroundColor: category.backgroundColor
          })
        }
      }
      return style
    },
    generateAfterStyle (date) {
      let style = {}
      for (let event of this.events) {
        if (date.isInRange(event.start, event.end, event.repeat) && date.getNextDay().isInRange(event.start, event.end, event.repeat)) {
          let category = this.eventCategories.find(item => item.id === event.categoryId) || {}
          Object.assign(style, {
            backgroundColor: category.backgroundColor
          })
        }
      }
      return style
    },
    goToday () {
      this.date = this.today
    },
    setEnableLeftArrow () {
      return this.enableControls
    },
    isEnableRightArrow () {
      return this.enableControls
    },
    buildCalendar() {
      this.date = Date.parse(this.initialDate) ? new DateTime(this.initialDate) : new DateTime()
      this.weekdays = this.generateWeekdayNames(this.firstDayOfWeek)
      if (!this.enableControls) {
        this.isLeftArrowEnabled  = false
        this.isRightArrowEnabled = false
      }
    },
    getWeekDaysOfSelectedDsate(date) {
      this.selectedDateFirstDayOfWeek = date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1)
    },
    isSelected (day) {
      if (!this.selectedCalendarDate) {
        return false
      }
      return  this.selectedDateFirstDayOfWeek < day.getDate() && this.selectedDateFirstDayOfWeek+6 > day.getDate() && day.toDateString() === new DateTime(this.selectedCalendarDate).toDateString()
    }
  },
  props: {
    initialDate: {
      type: String,
      default: null
    },
    enableControls: {
      type: Boolean,
      default: true
    },
    eventCursor: {
      type: String,
      default: ''
    },
    cursor: {
      type: String,
      default: ''
    },
    firstDayOfWeek: {
      type: Number,
      default: 1 // 1: Sunday, 2: Monday, etc
    },
    beginDate: {
      type: String,
      default: null
    },
    endDate: {
      type: String,
      default: null
    },
    eventCategories: {
      type: Array,
      default () {
        return []
      }
    },
    events: {
      type: Array,
      default () {
        return []
      }
    },
    offDays: {
      type: Array,
      default () {
        return [1, 7]
      }
    },
    allowOffDaySelect: {
      type: Boolean, 
      default: false
    },
    highlightWeek: {
      type: Boolean,
      default: false
    },
    highlightSelectDate: {
      type: Boolean,
      default: false
    },
    showNextPrevMonthDays: {
      type: Boolean,
      default: false
    }
  },
  beforeMount () {
    this.buildCalendar()
  }
}
</script>

<style lang="sass" scoped>
@import '../styles/index.sass'
</style>
